import { appendPx, fadeColor, getButtonSizes, getColor, lightenColor, styled } from "imaginarity-react-ui";

export class PlaylistEditSequenceLinearSC {

    public static NodeHeaderTitleDiv = styled.div`
      line-height: 40px;
      padding-left: 10px;
    `;
    public static NodeHeaderDotDiv = styled.div`
      float: left;
    `;
    public static NodeTextDiv = styled.div`
      margin-bottom: -10px;
    `;
    public static NodeTextHeightDiv = styled.div<{ hasError: boolean }>`
      height: 40px;
      line-height: 40px;
      color: ${p => p.hasError ? getColor(p, "@accentRed") : getColor(p, "@darkGrey")};
    `;
    public static AddPhaseBarDiv = styled.div`
      width: 100%;
      height: 40px;
      margin-bottom: 10px;
      background: linear-gradient(90deg, rgba(0,0,0,0.05) 30%, transparent 100%);
    `;
    public static NodeTitleDiv = styled.div``;

    public static StyledHeadlineInfo = styled.div`
      font-weight: bolder;
      line-height: 20px;
      text-align: left;
      padding: 10px;
      background: rgba(0,0,0,0.05);
      width: calc(100% + 26px);
      transform: translate(-13px, -13px);
    `;
    public static StyledHeadlineInfoText = styled.div`
      text-align: left;
      margin-bottom: 10px;
    `;
    public static StyledHeadlineGrid = styled.div`
      display: grid;
      grid-template-columns: 20px 1fr;
      column-gap: 10px;
      grid-template-rows: max-content;
      text-align: left;
      overflow: hidden;
    `;


    public static NodeContainer = styled.div<{ color?: string, selected: boolean, hasMissingElements: boolean }>`
    border: 1px solid ${p => getColor(p, p.hasMissingElements ? "@accentRed" : p.selected ? p.color ?? "color" : "@middleLightGrey")};
    position: relative;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 10px 20px -15px ${p => p.selected ? "#000" : "transparent"};
`;
    public static NodeConnectorV = styled.div`
    height: 20px; 
    width: 100%; 
    position: relative;
    margin-bottom: 2px;
    svg{
        margin-top: -1px;
    }
`;
    public static NodeBarInfo = styled.div`
    float: right;
    margin-top: 8px;
    margin-right: 10px;
    font-size: 0.8em;
    text-align: center;
    width: 24px;
    height: 24px;
    background: ${p => fadeColor(p, "@darkGrey", 4)};
    border-radius: 12px;
    line-height: 24px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 4px 8px -6px transparent;
    &:hover{
        background: ${p => getColor(p, "@mainBackground")};
        box-shadow: 0 4px 8px -6px black;
    }
`;
    public static NodeContent = styled.div`
    display: grid;
    //grid-template-columns: minmax(160px, max-content) 1fr ${p => appendPx(getButtonSizes(p.theme).buttonHeight)};
    grid-template-columns: minmax(160px, max-content) 1fr max-content;
    column-gap: 20px;
    row-gap: 5px;
    padding-left: 10px;
    margin-bottom: -5px;
    button>div{margin: 0;}
`;
    public static NodeConnectorH = styled.div<{ color: string }>`
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translate(-100%);
    width: 41px;
    height: 1px;
    background: ${p => getColor(p, p.color)};
    &:after{
        position: absolute;
        content: "";
        width: 9px;
        height: 9px;
        border-radius: 6px;
        top: -4px;
        left: -5px;
        background: ${p => getColor(p, p.color)};
    }
`
    public static PESCContainer = styled.div<{ sel: boolean }>`
    display: grid;
    grid-template-columns: 40px 150px 1fr max-content repeat(4, 28px) 40px;
    height: 40px;
    transition: all 0.2s ease-in-out;
    button>div{margin: 0;}
    .iconArea{
        border-left: ${p => p.sel ? `1px solid ${fadeColor(p, "@middleLightGrey", 8)}` : "none"};
        background: ${p => p.sel ? fadeColor(p, "@darkGrey", 2) : fadeColor(p, "@middleLightGrey", 4)};
        text-align: center;  
    }
    .selArea{
        border-left: ${p => p.sel ? `1px solid ${fadeColor(p, "@middleLightGrey", 8)}` : "none"};
        background: ${p => p.sel ? fadeColor(p, "@darkGrey", 2) : fadeColor(p, "@middleLightGrey", 4)};
        text-align: center;  
        width: 40px;      
    }
    .selAreaInv{
        border-left: none;
        background: transparent;
        text-align: center;        
        width: 0px;      
    }
`;

    public static NodeTitle = styled.div<{ missing?: boolean }>`
    line-height: 40px;
    font-weight: bolder;
    grid-column-start: 1;
    grid-column-end: 2;
    color: ${p => p.missing ? getColor(p, "@accent") : "inherit"};
`;
    public static NodesContentTitle = styled.div<{ missing?: boolean }>`
    line-height: 40px;
    font-weight: bolder;
    grid-column-start: 1;
    grid-column-end: 2;
    margin-left: -10px;
    padding-left: 10px;
    display: grid;
    grid-template-columns: 1fr ${p => appendPx(getButtonSizes(p.theme).buttonHeight)};
    color: ${p => p.missing ? getColor(p, "@accent") : "inherit"};
`;
    public static NodeButton = styled.div`
    grid-column-start: 3;
    grid-column-end: 4;
    text-align: center;
    padding-top: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    svg{
    transition: all 0.2s ease-in-out;
    }
    &:hover svg{
        stroke: ${p => getColor(p, "@accent")};
    }
    `;
    public static NodeText = styled.div<{ error?: boolean }>`
    line-height: 20px;
    padding: 10px 0;
    grid-column-start: 2;
    grid-column-end: 3;
    color: ${p => p.error ? getColor(p, "@middleLightGrey") : "inherit"};
    `;
    public static NodeTitleDescription = styled(this.NodeText)`
        line-height: unset;
    `;
    public static NodeInput = styled.div`
    line-height: 40px;
    grid-column-start: 2;
    grid-column-end: 3;
    min-width: 340px;
    width: 50%;
`;
    public static NodeDate = styled.div`
    line-height: 40px;
    grid-column-start: 2;
    grid-column-end: 3;
    margin-bottom: -15px;
    min-width: 340px;
    width: 50%;
    .react-datepicker__input-container{
        height: 40px;
    }
    svg{
        transform: translateY(-8px);
    }
`;
    public static NodeItemContainer = styled.div`
    grid-column-start: 1;
    grid-column-end: 4;
    transform: translateY(-10px);
    margin-bottom: 0px;
`;

    public static NodeHeader = styled.div<{ color: string, sel: boolean, showNode: boolean }>`
    background: ${p => p.sel ? fadeColor(p, p.color, 5) : getColor(p, "@veryLightGrey")};
    width: 100%;
    height: 40px;
    border-bottom: 1px solid ${p => getColor(p, p.showNode ? p.sel ? p.color : "@middleLightGrey" : "transparent")};
    display: grid;
    grid-template-columns: max-content 1fr max-content max-content max-content;
    button>div{margin: 0;}
`;
    public static NodeHeaderDot = styled.div<{ color: string }>`
    background: ${p => getColor(p, p.color)};
    width: 12px;
    height: 12px;
    border-radius: 6px;
    margin-top: 14px;
    margin-right: 10px;
    float: left;
`;


    public static Color = styled.div<{ color: string }>`
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: ${p => getColor(p, p.color)};
    float: right;
`;
    public static OptContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 30px 1fr;
`;
    public static SeqContainerOuter = styled.div<{ minWidth: number }>`
        display: grid;
        /* grid-template-columns: 1fr minmax(${p => p.minWidth}px, 2fr); */
        grid-template-columns: minmax(250px, 1fr) minmax(${p => p.minWidth}px, 2fr);
        margin-top: -15px;
        border: 1px solid  ${p => getColor(p, "@middleLightGrey")};
        padding: 10px;
        margin-bottom: -50px;
`;
    public static SeqContainer = styled.div<{ height: number, color: string }>`
    height: ${p => p.height}px;
    overflow-y: auto;
    width: 100%;
    z-index: 1;
    border-right: 1px solid ${p => getColor(p, p.color)};
    padding-left: 10px;
`;
    public static ImplContainer = styled.div<{ height: number }>`
    height: ${p => p.height}px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    z-index: 2;
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    padding: 10px 10px 20px 20px;
    margin-top: -15px;
    margin-bottom: -50px;
    position: relative;
    border-top: none;
    button>div{margin: 0;}
`;

    public static ImplContainerInfo = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr max-content;
    column-gap: 0px;
    margin-bottom: 0px;
    position: sticky;
    top: -15px;
    background: ${p => getColor(p, "@mainBackground")};
    padding-top: 15px;
`;

    public static TTFlag = styled.div`
    margin-top: -2px;
`;
    public static TTText = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
    public static PEAContainer = styled.div`
   margin-top: -15px;
   border: 1px solid  ${p => getColor(p, "@middleLightGrey")};
   border-top: none;
   padding: 10px;
   margin-bottom: 50px;
`;

    public static PEATriggerContainer = styled.div`
    margin: 10px 0px 20px 0px;
    display: grid;
    grid-template-columns: 1fr max-content;
    border: 1px solid  ${p => getColor(p, "@middleLightGrey")};
    background: ${p => fadeColor(p, "@darkGrey", 0)};
    padding: 10px;
    width: 100%;
    column-gap: 10px;
    transition: all 0.2s ease-in-out;

    &:hover{
        background: ${p => fadeColor(p, "@darkGrey", 2)};
        border: 1px solid ${p => lightenColor(p, "@middleLightGrey", 95)};
    }
`;

}